import {Box, styled} from '@mui/material';
import {FC, PropsWithChildren} from 'react';

export const ContractsTableAccordionContainer: FC<PropsWithChildren> = ({children}) => {
  return (
    <Container>
      <AbsoluteChildren>{children}</AbsoluteChildren>
    </Container>
  );
};

const Container = styled(Box)({
  position: 'relative',
  minHeight: 40,
  width: 298,
});

const AbsoluteChildren = styled(Box)({
  position: 'absolute',
  top: 0,
  zIndex: 5,
});
